import React from 'react';
import { format } from 'date-fns';

interface CustomProps {
  format: string;
  record: {
    startDate: string | Date;
    endDate: string | Date;
  };
}

const Component: React.SFC<CustomProps> = (props) => {
  const startDate = props.record.startDate
    ? format(new Date(props.record.startDate), props.format)
    : '';
  const endDate = props.record.endDate
    ? format(new Date(props.record.endDate), props.format)
    : '';
  return (
    <div className="CrudTextField">
      {startDate + (startDate && endDate ? ' - ' : '') + endDate}
    </div>
  );
};

Component.defaultProps = {
  format: '',
};

export default Component;
